export default {"src":"/_next/static/media/pen-paper.393e1d12.svg","height":47,"width":46,"blurWidth":0,"blurHeight":0};